const globalSetting = {
    publicParams: {
        SystemID: "10",
        BusinessID: "114",
    }
};

export default globalSetting;